import API from 'util/API';


export const queryUsers = async (query) => {
  if(!query || query.length < 4) {
    return [];
  }

  const response = await API.get(`/queryUser?username=${query}`);
  if (response && response.data && response.data.users) {
    return response.data.users;
  }
  return [];
}

export const queryRestaurantUsers = async () => {
  const response = await API.get(`/merchantUsers`);
  if (response && response.data && response.data.users) {
    return response.data.users;
  }
  return [];
}

// Get all customers
export const getCustomers = async () => {
  const response = await API.get('/customers');
  return response.data;
};

// Get transactions by date
export const getTransactions = async (dateStr, showDeletedTransactions = false) => {
  const response = await API.post(`/transactions?dateStr=${dateStr}`, { 
    showDeletedTransactions 
  });
  return {
    transactions: response.data.transactions || [],
    canDeleteTransactions: response.data.canDeleteTransactions || false,
    canDeleteInvoiceTransctions: response.data.canDeleteInvoiceTransctions || false
  };
};

// Update/Delete transactions
export const updateTransactions = async (transactionIds, dateStr, reason) => {
  const response = await API.post('/updateTransactions', { 
    transactionIds, 
    dateStr, 
    reason 
  });
  return response.data;
};